import Vue from 'vue';
import helpDialog from './help-dialog';

const helpers = {
  helpDialog
};

export default {
  install () {
    Vue.helpers = helpers;
    Vue.prototype.$helpers = helpers;
  }
};
